<template>
  <v-dialog v-model="dialogVisible" max-width="500" persistent>
    <v-card>
      <v-card-title>
        <span>{{ isEdit ? 'Edit IMSI Type' : 'Add IMSI Type' }}</span>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="form.name"
          label="Name"
          :rules="[v => !!v || 'Name is required']"
          required
          variant="outlined"
          density="compact"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="close">Cancel</v-btn>
        <v-btn color="primary" variant="flat" @click="save" :disabled="!form.name">
          {{ isEdit ? 'Update' : 'Add' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ImsiTypeDialog',
  props: {
    modelValue: { type: Boolean, default: false },
    editItem: { type: Object, default: null }
  },
  emits: ['update:modelValue', 'save'],
  data() {
    return {
      form: {
        id: null,
        name: ''
      }
    };
  },
  computed: {
    dialogVisible: {
      get() { return this.modelValue; },
      set(val) { this.$emit('update:modelValue', val); }
    },
    isEdit() {
      return !!this.editItem;
    }
  },
  watch: {
    modelValue(val) {
      if (val && this.editItem) {
        this.form.id = this.editItem.id;
        this.form.name = this.editItem.name;
      } else if (val) {
        this.form.id = null;
        this.form.name = '';
      }
    }
  },
  methods: {
    save() {
      if (!this.form.name) return;
      this.$emit('save', { ...this.form });
      this.close();
    },
    close() {
      this.dialogVisible = false;
    }
  }
});
</script>
